/**
 * Utility functions for formatting values
 */

/**
 * Format a number as currency (MXN)
 * Example: 1234.5 -> $1,234.50
 */
export const formatCurrency = (value: number | string | undefined | null): string => {
    if (value === undefined || value === null) return '$0.00';

    const numValue = typeof value === 'string' ? parseFloat(value) : value;

    if (isNaN(numValue)) return '$0.00';

    return new Intl.NumberFormat('es-MX', {
        style: 'currency',
        currency: 'MXN',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(numValue);
};
